export default __webpack_public_path__ + "static/media/100_19528.6ef4bee8.jpg";